import React from 'react';
import MainPageCompenent from './MainPageCompenent';
import ScoreList from './ScoreList';

function ScoreDetail(props) {
    return (
        <MainPageCompenent>
            <ScoreList mainTitle="لیست امتیازات" isMerchant={false}/>
        </MainPageCompenent>
    );
}

export default ScoreDetail;
